import React, { useState, useEffect } from "react";
import { useCompany } from "../../Context/CompanyContext";
import { ciudadesPeru } from "../../Data/PeruDistricts"; // Reutilizamos las ciudades del Step5
import { fetchWithAuth } from "../../Context/UserContext";
import API_URL from "../../config";
import { Card, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { cn } from "../../lib/utils";
import { toast } from "sonner";

const Zonas = () => {
  const { companies, fetchCompanies } = useCompany();
  const [operacionGeografica, setOperacionGeografica] = useState([]); // Estado inicial como arreglo
  const [error] = useState("");
  const id_company = companies?.company?.id_company;

  useEffect(() => {
    if (companies?.profile?.operacion_geografica) {
      try {
        // Verificar si operacion_geografica es una cadena y deserializarla
        const savedCities = Array.isArray(
          companies.profile.operacion_geografica
        )
          ? companies.profile.operacion_geografica
          : JSON.parse(companies.profile.operacion_geografica || "[]");
        setOperacionGeografica(savedCities);
      } catch (error) {
        console.error("Error al parsear operacion_geografica:", error);
        setOperacionGeografica([]); // En caso de error, inicializar como un arreglo vacío
      }
    }
  }, [companies]);

  const toggleCitySelection = (city) => {
    setOperacionGeografica((prev) => {
      if (!Array.isArray(prev)) return []; // Validar que prev es un arreglo
      return prev.includes(city)
        ? prev.filter((c) => c !== city) // Quitar la ciudad si está seleccionada
        : [...prev, city]; // Agregar la ciudad si no está seleccionada
    });
  };

  const handleSaveZonas = async () => {
    try {
      const response = await fetchWithAuth(
        `${API_URL}/bs/company-profile/${id_company}/update-zonas`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            profile: {
              cities: operacionGeografica, // Enviar las ciudades seleccionadas
            },
          }),
        }
      );

      if (response.ok) {
        toast.success("Zonas actualizadas exitosamente.");

        // Actualizar el contexto global
        fetchCompanies();
      } else {
        const data = await response.json();
        toast.error(`Error al actualizar zonas: ${data.error}`);
      }
    } catch (error) {
      console.error("Error en la actualización de zonas:", error);
      toast.error("Error al actualizar zonas.");
    }
  };

  return (
    <Card>
      <CardContent className="space-y-3 pt-6">
        <h3 className="text-lg font-semibold text-foreground">Zonas de Operación</h3>
        <p className="text-sm text-muted-foreground">
          <strong className="text-foreground">Selecciona las ciudades</strong> donde tienes operaciones:
        </p>

        <div className="flex flex-wrap gap-2">
          {ciudadesPeru.map((city) => (
            <button
              key={city}
              type="button"
              onClick={() => toggleCitySelection(city)}
              className={cn(
                "rounded-md border border-border px-3 py-1.5 text-sm hover:bg-muted",
                operacionGeografica.includes(city) && "border-primary bg-primary/10 text-primary"
              )}
            >
              {city}
            </button>
          ))}
        </div>

        {error && <p className="text-sm text-destructive">{error}</p>}

        <Button onClick={handleSaveZonas}>Guardar Zonas</Button>
      </CardContent>
    </Card>
  );
};

export default Zonas;
